import React from 'react';
import {
    hasPermission,
    getCurrentUser,
    getUserPermissions,
    isAdminOrSubAdmin,
    isSupportViewer
} from '../utils/permissionUtils';

const PermissionGuard = (props: any) => {
    const [allowedPermissions, setAllowedPermissions] = React.useState<string[]>([]);
    const [userType, setUserType] = React.useState('');

    React.useEffect(() => {
        const perms = getUserPermissions();
        const user = getCurrentUser();
        const roleObj: any = user?.role;
        const rawRole = (typeof roleObj === 'object' && roleObj !== null ? roleObj?.role_name : roleObj) || user?.user_type || '';
        setUserType(String(rawRole || '').toUpperCase().trim());
        setAllowedPermissions(perms);
    }, []);

    const role = userType || '';
    const isSyncOperation =
        props.isSync === true ||
        props.action === 'sync' ||
        (props.route && String(props.route).toLowerCase().includes('sync'));

    let isAllowed = false;

    if (isAdminOrSubAdmin(role)) {
        // ADMIN and SUBADMIN have equal full permissions to perform or view any action
        isAllowed = true;
    } else if (isSupportViewer(role)) {
        // SUPPORT_VIEWER can view pages and perform SYNC operations, but CANNOT perform Add, Edit, Delete, or Change Status.
        if (isSyncOperation || props.action === 'view') {
            isAllowed = true;
        } else {
            isAllowed = false;
        }
    } else {
        // Standard user fallback based on stored allowed permissions
        isAllowed = hasPermission(props.route, allowedPermissions, role);
    }

    if (isAllowed) {
        return <>{props.children}</>;
    }

    // Render as disabled if mode === 'disable' is explicitly specified
    if (props.mode === 'disable') {
        return (
            <div style={{ cursor: 'not-allowed' }}>
                <div style={{ opacity: 0.3, pointerEvents: 'none' }}>
                    {React.Children.map(props.children, (child) => {
                        if (
                            React.isValidElement(child) &&
                            child.props &&
                            typeof child.props === 'object' &&
                            child.props !== null &&
                            'disabled' in child.props
                        ) {
                            return React.cloneElement(child as React.ReactElement<any>, { disabled: true });
                        }
                        return child;
                    })}
                </div>
            </div>
        );
    }

    // Default: hide element completely for unauthorized actions
    return null;
};

export default PermissionGuard;
